import React from 'react';
// Import the icons you need from React Icons
import { FaQuestionCircle } from 'react-icons/fa';
import { HiOutlineShoppingCart } from "react-icons/hi";

const Label: React.FC = () => {
  return (
    <nav className="bg-[#f98715] py-2 px-2 sm:py-1 sm:px-1"> {/* Reduced padding for mobile */}
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
        {/* Text Instead of Logo with Splash Animation */}
        <div className="text-white text-md  lg:text-lg font-bold mb-0 md:mb-0 sm:mb-0"> {/* Reduced margin for mobile */}
          <div className="splash-text animate-splash">"Wholesome bites,wag-worthy delights🐾"</div>
        </div>
        
        {/* Hidden on Mobile, Visible on Medium and Larger Screens */}
        <ul className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6 text-white items-center hidden md:flex">
          {/* Get App Link with Phone Icon */}
          <li className="flex items-center md:border-r-2 pr-3">
            <HiOutlineShoppingCart className="mr-2 text-lg md:text-lg" /> {/* Mobile Icon */}
            <a href="/products" className="hover:text-gray-400 text-base md:text-md">Product</a>
          </li>

          {/* Help Link with Help Icon */}
          <li className="flex items-center">
            <FaQuestionCircle className="mr-2 text-xl md:text-lg" /> {/* Help Icon */}
            <a href="/contact" className="hover:text-gray-400 text-base md:text-md">Help</a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Label;
